'use es6';

import $ from 'jquery';
import Immutable from 'immutable';
var selectors = Immutable.Map({
  htmlAndBody: 'html, body'
});
export default {
  /**
   * Scroll to a particular node on the page.
   *
   * @param {Node|String} scrollToNode - Node to scroll to
   */
  scrollTo: function scrollTo(scrollToNode) {
    $(selectors.get('htmlAndBody')).animate({
      scrollTop: $(scrollToNode).offset().top
    }, 1000);
  }
};